import { createSlice } from "@reduxjs/toolkit";
import { fetchProducts, getProducts } from "../api/products";

const initialState = {
  // paginated products (main listing page)
  products: [],
  total: 0,
  page: 1,
  totalPages: 0,

  // full list (optional usage)
  allProducts: [],

  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    clearProducts: (state) => {
      state.products = [];
      state.allProducts = [];
      state.total = 0;
      state.page = 1;
      state.totalPages = 0;
      state.error = null;
    },

    // optional: reset pagination when filters change
    resetPagination: (state) => {
      state.page = 1;
    },
  },

  extraReducers: (builder) => {
    builder

      // ---------------- FULL PRODUCT LIST ----------------
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;

        state.allProducts = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.products || [];
      })

      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      // ---------------- PAGINATED PRODUCTS ----------------
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getProducts.fulfilled, (state, action) => {
        state.loading = false;

        // 🔥 SAFE ACCESS (prevents crashes)
        const payload = action.payload?.data || action.payload;

        state.products = payload.products || [];
        state.total = payload.total || 0;
        state.page = payload.page || 1;
        state.totalPages = payload.totalPages || 0;
      })

      .addCase(getProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearProducts, resetPagination } = productSlice.actions;

export default productSlice.reducer;
